import { useEffect, useRef, useState } from 'react';
import { generarTokenPractica, seleccionarPrescripcion } from '../../services/Seo/OrdenDigital';
import { getImprimirOrden } from '../../services/Seo/Orden';
import { sendMessageOrdenCancelada } from '../../services/WebSocket/WebSocket';
import { Box, Grid } from '@mui/material';
import { SUCCESS, WARNING } from '../../@iosper/components/LoadingButton/LoadingAlert';
import { useForm } from 'react-hook-form';
import { useUser } from '../Auth/User';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import OrdenDigitalQRMessageEvent from './OrdenDigitalQRMessageEvent';
import OrdenDigitalQRPreview from './OrdenDigitalQRPreview';
import OrdenPreview from './OrdenPreview';
import PrestadorSelect from '../Prestador/PrestadorSelect';
import PrescripcionesVigentesTable from './PrescripcionesVigentesTable';
import QrCodeIcon from '@mui/icons-material/QrCode';
import Typography from '@mui/material/Typography';
import { getPrestadorLogueado } from '../../services/Busquedas/Prestadores';
import { LoadingButton } from '@mui/lab';
import { getConsultorioLogueado } from '../../services/Busquedas/Prestadores';

const WS_STATE_QR_ESCANEADO = 'QrEscaneado';
const WS_STATE_SIN_PRESCRIPCIONES_ELECTRONICAS = 'SinPrescripcionesElectronicas';
const WS_STATE_AUTORIZADO_LISTAR_PRESCRIPCIONES = 'AutorizadoListarPrescripciones';
const WS_STATE_ERROR_AUTORIZADO_LISTAR_PRESCRIPCIONES = 'ErrorAutorizadoListarPrescripciones';
const WS_STATE_PRESCRIPCION_SELECCIONADA = 'PrescripcionSeleccionada';
const WS_STATE_ERROR_PRESCRIPCION_SELECCIONADA = 'ErrorPrescripcionSeleccionada';
const WS_STATE_ORDEN_GENERADA = 'OrdenGenerada';
const WS_STATE_ORDEN_CANCELADA = 'OrdenCancelada';
const WS_STATE_ERROR_ORDEN = 'ErrorOrden';
const WS_STATE_ERROR_QR_ESCANEADO = 'ErrorQrEscaneado';

const EmitirOrdenPracticaDigital = () => {
  const { user } = useUser();

  const [keyComponentSelectPrestador, setKeyComponentSelectPrestador] = useState(0);
  const [loadingOrden, setLoadingOrden] = useState(false);
  const [selectedPrestador, setSelectedPrestador] = useState(null);
  const [prestadorLogueado, setPrestadorLogueado] = useState(null);
  const [consultorioLogueado, setConsultorioLogueado] = useState(null);
  const [socket, setSocket] = useState(null);

  // Dialog Orden Preview
  const [datosOrdenGenerada, setDatosOrdenGenerada] = useState('');
  const [openDialogReporte, setOpenDialogReporte] = useState(false);
  const [urlReporte, setUrlReporte] = useState('');

  // Dialog Orden QR Preview
  const [openQRPreview, setOpenQRPreview] = useState(false);
  const [qrValue, setQrValue] = useState('');

  // Dialog QR Messages Event Preview
  const [messageQr, setMessageQr] = useState('');
  const [qrMessageEventOpen, setQrMessageEventOpen] = useState(false);
  const [qrMessageEventStatus, setQrMessageEventStatus] = useState();

  // Prescripciones vigentes (recibidas vía WS)
  const [prescripciones, setPrescripciones] = useState([]);
  const [afiliadoData, setAfiliadoData] = useState(null);
  const [showPrescripciones, setShowPrescripciones] = useState(false);
  const [loadingSeleccion, setLoadingSeleccion] = useState(false);
  const httpErrorMsgRef = useRef(null);
  const prestadorCanceloRef = useRef(false);

  useEffect(() => {
    if (qrValue !== '') {
      conectarWebSocket(qrValue);
    }
  }, [qrValue]);

  useEffect(() => {
    const getPrestador = async () => {
      const prestador = await getPrestadorLogueado();
      if (prestador != null) {
        setPrestadorLogueado(prestador);
        setSelectedPrestador(prestador);
      } else {
        const consultorio = await getConsultorioLogueado();
        if (consultorio != null) {
          setConsultorioLogueado(consultorio);
        }
      }
    };

    if (prestadorLogueado === null) {
      getPrestador();
    }
  }, []);

  const conectarWebSocket = (tokenQr) => {
    const ws = new WebSocket(
      `${process.env.REACT_APP_WEBSOCKET_URL}?tokenQr=${tokenQr}&token=${localStorage.getItem('token')}`,
    );
  

    ws.onmessage = function (e) {
      const mssg = JSON.parse(e.data);
      if (String(mssg.token) === String(tokenQr)) {
        switch (mssg.state) {
          case WS_STATE_ORDEN_CANCELADA: {
            if (prestadorCanceloRef.current) {
              setOpenQRPreview(false);
              setShowPrescripciones(false);
              setQrMessageEventOpen(false);
              ws.close();
            } else {
              setOpenQRPreview(false);
              setShowPrescripciones(false);
              setQrMessageEventOpen(true);
              setMessageQr(mssg.message || 'La orden fue cancelada por el afiliado.');
              setQrMessageEventStatus(WARNING);
              ws.close();
            }
            break;
          }
          case WS_STATE_ERROR_ORDEN:
          case WS_STATE_ERROR_QR_ESCANEADO:
          case WS_STATE_ERROR_AUTORIZADO_LISTAR_PRESCRIPCIONES: {
            setOpenQRPreview(false);
            setShowPrescripciones(false);
            setQrMessageEventOpen(true);
            setMessageQr(mssg.message);
            setQrMessageEventStatus(WARNING);
            ws.close();
            break;
          }
          case WS_STATE_ERROR_PRESCRIPCION_SELECCIONADA: {
            setOpenQRPreview(false);
            setShowPrescripciones(false);
            setQrMessageEventOpen(true);
            setMessageQr(httpErrorMsgRef.current || mssg.message);
            httpErrorMsgRef.current = null;
            setQrMessageEventStatus(WARNING);
            ws.close();
            break;
          }
          case WS_STATE_ORDEN_GENERADA: {
            const orden = mssg.data;
            setShowPrescripciones(false);
            setQrMessageEventOpen(false);
            setDatosOrdenGenerada(orden);
            imprimirOrden(orden);
            ws.close();
            break;
          }
          case WS_STATE_QR_ESCANEADO: {
            setOpenQRPreview(false);
            setQrMessageEventOpen(true);
            setQrMessageEventStatus(SUCCESS);
            setMessageQr('QR escaneado. Esperando autorización del afiliado...');
            break;
          }
          case WS_STATE_SIN_PRESCRIPCIONES_ELECTRONICAS: {
            setOpenQRPreview(false);
            setShowPrescripciones(false);
            setQrMessageEventOpen(true);
            setQrMessageEventStatus(WARNING);
            setMessageQr('El afiliado no tiene prescripciones electrónicas vigentes.');
            ws.close();
            break;
          }
          case WS_STATE_AUTORIZADO_LISTAR_PRESCRIPCIONES: {
            setQrMessageEventOpen(false);
            setPrescripciones(mssg.data?.prescripciones || []);
            setAfiliadoData(mssg.data?.afiliado || null);
            setShowPrescripciones(true);
            break;
          }
          case WS_STATE_PRESCRIPCION_SELECCIONADA: {
            setQrMessageEventOpen(true);
            setQrMessageEventStatus(SUCCESS);
            setMessageQr('Esperando confirmación del afiliado para generar la orden...');
            break;
          }
          default:
            break;
        }
      } 
    };

    setSocket(ws);
  };

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });

  const handlerLimpiar = () => {
    reset();
    reset();
    setSelectedPrestador(null);
    setKeyComponentSelectPrestador(1 + Math.random() * (1000 - 1));
    setLoadingOrden(false);
    setShowPrescripciones(false);
    setPrescripciones([]);
    setAfiliadoData(null);
    setLoadingSeleccion(false);
    prestadorCanceloRef.current = false;
    if (socket) socket.close();
  };

  const handlerCerrarQRMessageEvent = async () => {
    setQrMessageEventOpen(false);
    // Marcar que fue el prestador quien canceló (solo si no fue una cancelación del afiliado)
    if (!prestadorCanceloRef.current) {
      prestadorCanceloRef.current = true;
    }
    // Notificar al afiliado que fue cancelado el flujo
    if (qrValue) {
      try {
        await sendMessageOrdenCancelada(qrValue);
      } catch (wsError) {
        console.log('Error al enviar cancelación:', wsError);
      }
    }
    handlerLimpiar();
  };

  const handlerCerrarQRPreview = async () => {
    setOpenQRPreview(false);
    // Marcar que fue el prestador quien canceló
    prestadorCanceloRef.current = true;
    // Notificar al afiliado que fue cancelado el flujo
    if (qrValue) {
      try {
        await sendMessageOrdenCancelada(qrValue);
      } catch (wsError) {
        console.log('Error al enviar cancelación:', wsError);
      }
    }
    handlerLimpiar();
  };

  const handlerCerrarPreview = () => {
    handlerLimpiar();
  };

  const handlerCancelarOrden = async () => {
    prestadorCanceloRef.current = true;
    // Notificar al afiliado que fue cancelado el flujo
    if (qrValue) {
      try {
        await sendMessageOrdenCancelada(qrValue);
      } catch (wsError) {
        console.log('Error al enviar cancelación:', wsError);
      }
    }
    // Limpiar estados pero mantener el prestador seleccionado
    setLoadingOrden(false);
    setShowPrescripciones(false);
    setPrescripciones([]);
    setAfiliadoData(null);
    setOpenQRPreview(false);
    setQrMessageEventOpen(false);
    setLoadingSeleccion(false);
    setQrValue('');
    if (socket) socket.close();
  };

  const onSubmit = async (data, event) => {
    setLoadingOrden(true);
    event.preventDefault();

    try {
      const tokenQr = await generarTokenPractica(getDataOrdenDigital());
      setQrValue(tokenQr);
      setOpenQRPreview(true);
    } catch (e) {
      setLoadingOrden(false);
    }
  };

  const handleSeleccionarPrescripcion = async (prescripcion) => {
    setLoadingSeleccion(true);
    try {
      await seleccionarPrescripcion({
        token: qrValue,
        idPrescripcion: prescripcion.prescripcionElectronica?.idPrescripcionElectronica,
        idAfiliado: afiliadoData?.idAfiliado,
      });
      setShowPrescripciones(false);
      setQrMessageEventOpen(true);
      setQrMessageEventStatus(SUCCESS);
      setMessageQr('Esperando confirmación del afiliado para generar la orden...');
    } catch (e) {
      const errorMsg = e?.response?.data?.error || e?.response?.data?.message || 'Error al seleccionar la prescripción.';
      httpErrorMsgRef.current = errorMsg;
      setShowPrescripciones(false);
      setQrMessageEventOpen(true);
      setQrMessageEventStatus(WARNING);
      setMessageQr(errorMsg);
    } finally {
      setLoadingSeleccion(false);
    }
  };

  const imprimirOrden = async (token) => {
    const resGenerada = await getImprimirOrden({
      numeroOrden: token.orden.numeroOrdenSinFormato,
      codigoTransaccion: token.orden.codigoTransaccion,
    });

    setUrlReporte(resGenerada);
    setOpenDialogReporte(true);
  };

  const getDataOrdenDigital = () => ({
    codigoPrestador: selectedPrestador.matricula,
    tipoPrestador: selectedPrestador.tipo,
    descripcionTipo: selectedPrestador.descripcionTipo,
    nombre: selectedPrestador.nombre,
    nombreUsuario: user?.nombre,
  });

  const handlerSelectPrestador = (prestador) => {
    setSelectedPrestador(prestador);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card sx={{ width: '100%', p: 1 }}>
          <CardContent>
            <Typography gutterBottom variant='h5'>
              Generar Orden de Práctica Electrónica
            </Typography>
            <Typography gutterBottom>
              Acá podrás generar un QR para que el afiliado autorice el acceso a sus prescripciones
              electrónicas vigentes desde su aplicación mi.oser.
            </Typography>
          </CardContent>

          {!showPrescripciones && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <CardContent>
                <Grid container spacing={3} alignItems='center'>
                  <Grid item xs={12}>
                    <PrestadorSelect
                      key={keyComponentSelectPrestador + '_prestador'}
                      value={selectedPrestador}
                      disabled={!consultorioLogueado && selectedPrestador !== null}
                      name='prestadorRegister'
                      {...register('prestadorRegister', {
                        validate: () => selectedPrestador?.idPrestador || false,
                      })}
                      onSelectPrestador={handlerSelectPrestador}
                    />
                  </Grid>
                </Grid>
                {errors.prestadorRegister && errors.prestadorRegister.type === 'validate' && (
                  <p style={{ color: 'red' }}>Debe seleccionar el prestador</p>
                )}
              </CardContent>
              <CardActions sx={{ px: 2 }}>
                <Grid container>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 2,
                      }}
                    >
                      <LoadingButton
                        variant='contained'
                        size='medium'
                        color='primary'
                        startIcon={<QrCodeIcon />}
                        type='submit'
                        loading={loadingOrden}
                      >
                        Generar
                      </LoadingButton>
                    </Box>
                  </Grid>
                </Grid>
              </CardActions>
            </form>
          )}

          {showPrescripciones && (
            <CardContent>
              <PrescripcionesVigentesTable
                prescripciones={prescripciones}
                afiliado={afiliadoData}
                onSeleccionar={handleSeleccionarPrescripcion}
                loading={loadingSeleccion}
              />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <LoadingButton
                  variant='contained'
                  color='neutral'
                  size='small'
                  onClick={handlerCancelarOrden}
                >
                  Cancelar
                </LoadingButton>
              </Box>
            </CardContent>
          )}
        </Card>

        {/* QR */}
        <OrdenDigitalQRPreview
          open={openQRPreview}
          setOpen={openQRPreview}
          qrValue={qrValue}
          prestador={selectedPrestador}
          handlerCerrarPreview={handlerCerrarQRPreview}
          generarTokenFn={generarTokenPractica}
          mensajeEspera='Esperando a que el afiliado lea el QR y autorice el acceso a sus prescripciones desde mi.oser'
        ></OrdenDigitalQRPreview>
        {/* Messages */}
        <OrdenDigitalQRMessageEvent
          open={qrMessageEventOpen}
          prestador={selectedPrestador}
          message={messageQr}
          status={qrMessageEventStatus}
          onHandleCerrar={handlerCerrarQRMessageEvent}
        ></OrdenDigitalQRMessageEvent>
        {/* Orden */}
        <OrdenPreview
          open={openDialogReporte}
          setOpen={setOpenDialogReporte}
          urlReporte={urlReporte}
          datosOrden={datosOrdenGenerada}
          nombreReporte={'Orden_oser_' + datosOrdenGenerada.numeroOrden}
          handlerCerrarPreview={handlerCerrarPreview}
          showDownload={false}
          showPrint={false}
          showSuccessIcon
          showAttachInstruction
        ></OrdenPreview>
      </Grid>
    </Grid>
  );
};

export default EmitirOrdenPracticaDigital;
